export const getDataSearch = state => state.globalSearchReducer.data

export const getMetaSearch = state => state.globalSearchReducer.meta

export const isLoading = state => state.globalSearchReducer.isLoading

export const isLoadingPagination = state => state.globalSearchReducer.isLoadingPagination

export const globalSearchOptions = state => state.globalSearchReducer.options
